import React from 'react'
import { DashboardLayout } from '../../layouts'
import { Breadcrumb } from '../../components'
import { Form, Sidebar } from './components'

const routes = [
  {
    name: 'Dashboard',
    route: '/dashboard'
  },
  {
    name: 'Our Resources',
    route: '/dashboard/resources'
  },
]

const DashboardResourceForm = () => {
  return (
    <DashboardLayout title="Edit Resource">
      <div className="hidden xl:block">
        <Breadcrumb routes={routes}/>
        <h1 className="text-4xl font-bold font-primary">
          Create / Edit Resource
        </h1>
        <hr className="mt-5 mb-8"/>
      </div>

      <div className="flex flex-wrap -mx-4 lg:pt-10 xl:pt-0">
        <div className="w-full lg:w-2/3 pl-4 pr-4 lg:pr-8">
          <Form />
        </div>
        <div className="w-full lg:w-1/3 px-4">
          <Sidebar />
        </div>
      </div>
    </DashboardLayout>
  )
}

export { DashboardResourceForm }
